import { render, staticRenderFns } from "./AvailableUpdatesList.vue?vue&type=template&id=8d3e435c&scoped=true"
import script from "./AvailableUpdatesList.vue?vue&type=script&lang=js"
export * from "./AvailableUpdatesList.vue?vue&type=script&lang=js"
import style0 from "./AvailableUpdatesList.vue?vue&type=style&index=0&id=8d3e435c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3e435c",
  null
  
)

export default component.exports